import { Box, Divider, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import FigmaPluginCover from "../../../../assets/images/figma-plugin-cover.png";
import FigmaInstallSection from "../FigmaInstallSection/FigmaInstallSection";
import styles from "./FigmaHeaderSection.module.scss";

const FigmaHeaderSection: React.FC = () => {
	const { t } = useTranslation("translation", { keyPrefix: "figma.headerSection" });
	const isBigScreen = useMediaQuery("(min-width:2460px)");

	return (
		<Box className={styles.headerContainer}>
			<Box className={styles.headerSection}>
				<Box className={styles.textContainer}>
					<Typography className={styles.title}>{t("title")}</Typography>

					<Typography className={styles.description}>{t("description1")}</Typography>

					<Typography className={styles.benefitsTitle}>{t("keyBenefits")}</Typography>

					<Typography className={styles.description}>
						<span className={styles.descriptionBold}>{t("benefit1.title")}</span>
						{t("benefit1.description")}
					</Typography>

					<Typography className={styles.description}>
						<span className={styles.descriptionBold}>{t("benefit2.title")}</span>
						{t("benefit2.description")}
					</Typography>

					{isBigScreen && <FigmaInstallSection />}
				</Box>

				<Box className={styles.imageContainer}>
					<img src={FigmaPluginCover} />
				</Box>
			</Box>

			<Divider className={styles.divider} />
		</Box>
	);
};

export default FigmaHeaderSection;
